import { render, staticRenderFns } from "./AgendaListOfSessionsTable.vue?vue&type=template&id=07e4a796&scoped=true&"
import script from "./AgendaListOfSessionsTable.vue?vue&type=script&lang=js&"
export * from "./AgendaListOfSessionsTable.vue?vue&type=script&lang=js&"
import style0 from "./AgendaListOfSessionsTable.vue?vue&type=style&index=0&id=07e4a796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e4a796",
  null
  
)

export default component.exports